import * as React from "react";
import styled from "styled-components";
import Link from "next/link";
import { Color, Ease } from "@styles/constants";

import { ReactComponent as CaretBackSVG } from "@images/caret_back.svg";

const BackButton: React.FC<{ href: string }> = ({ href }) => (
  <StyledBackButton href={href}>
    <CaretBackSVG />
    <span>Back</span>
  </StyledBackButton>
);

export default BackButton;

const StyledBackButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 8px 20px;
  text-decoration: none;
  border-radius: 48px;
  border: 1px solid ${Color.blackBrand};
  background: ${Color.white};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
  transition: background ${Ease.duration} ${Ease.out}, color ${Ease.duration} ${Ease.out};
  pointer-events: all;

  svg {
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-right: 5px;
    fill: ${Color.blackBrand};
    transition: fill ${Ease.duration} ${Ease.out};
  }

  &:focus-visible,
  &:hover {
    background: ${Color.goldAsh};
  }
`;
